export const decodeToken = () => {
  const token = localStorage.getItem("authUser");
  if (!token) return null;

  try {
    return JSON.parse(atob(token.split(".")[1]))
  } catch (e) {
    return null;
  }
}

export const getUserRoleFromToken = () => {
  try {
    const payload = decodeToken();
    return payload.role || null;
  } catch (e) {
    return null;
  }
}
